// Servicio de operaciones de administración (CRUD de categorías y publicaciones).
// Todas las llamadas van por apiFetch con `auth: true` (Bearer + cierre de sesión en 401).
// La institución sobre la que se opera la resuelve la API: por el claim del JWT del usuario o,
// para usuarios de plataforma, por el encabezado X-Institucion que apiFetch añade.

import { apiFetch, json } from './apiFetch';

// --- Categorías ---
// `institucionSlug` (opcional) fuerza la institución consultada: sólo tiene efecto para un SuperAdmin.
export const getCategoriasAdmin = (institucionSlug) =>
  apiFetch('/api/admin/categorias', { auth: true, institucion: institucionSlug });

// datos: { nombre, descripcion, padreId, orden, tipoOrden, moverPublicaciones? }
export const crearCategoria = (datos) =>
  apiFetch('/api/admin/categorias', { method: 'POST', auth: true, ...json(datos) });

export const actualizarCategoria = (id, datos) =>
  apiFetch(`/api/admin/categorias/${id}`, { method: 'PUT', auth: true, ...json(datos) });

export const cambiarEstadoCategoria = (id, activo) =>
  apiFetch(`/api/admin/categorias/${id}/estado`, { method: 'PATCH', auth: true, ...json({ activo }) });

export const eliminarCategoria = (id) =>
  apiFetch(`/api/admin/categorias/${id}`, { method: 'DELETE', auth: true });

// --- Publicaciones ---
export const getPublicacionesAdmin = (categoriaId) => {
  const query = categoriaId ? `?categoriaId=${encodeURIComponent(categoriaId)}` : '';
  return apiFetch(`/api/admin/publicaciones${query}`, { auth: true });
};

export const getPublicacionAdmin = (id) =>
  apiFetch(`/api/admin/publicaciones/${id}`, { auth: true });

// formData con campos PascalCase (CategoriaId, Titulo, Descripcion, Orden, FechaPublicacion, Archivo).
export const crearPublicacion = (formData) =>
  apiFetch('/api/admin/publicaciones', { method: 'POST', auth: true, body: formData });

export const actualizarPublicacion = (id, formData) =>
  apiFetch(`/api/admin/publicaciones/${id}`, { method: 'PUT', auth: true, body: formData });

export const cambiarEstadoPublicacion = (id, activo) =>
  apiFetch(`/api/admin/publicaciones/${id}/estado`, { method: 'PATCH', auth: true, ...json({ activo }) });

export const eliminarPublicacion = (id) =>
  apiFetch(`/api/admin/publicaciones/${id}`, { method: 'DELETE', auth: true });
